import React from 'react';

function Modal({ themeClass = '', children }) {

    const getBGClassName = (theme) => {
        switch (theme) {
            case 'mimetika-web':
                return 'bg-blue-dark';
            case 'mimetika-web-wl1':
                return 'bg-black';
            case 'mimetika-web-ov':
                return 'bg-green-dark';
            default:
                return 'bg-default';
        }
    };

    return (
        <div className="modal m-0">
            <div className={`modal-content py-3 px-2 sm:py-6 sm:px-4 ${getBGClassName(themeClass)}`}>
                <div className="modal-body overflow-auto">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;
